import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { IConfig } from '../../../Interfaces/IConfig';

export type IDsgvoDialogProps = {
  configObject: IConfig;
  open: boolean;
  handleClose: () => void;
};

export function DsgvoDialog({
  configObject,
  open,
  handleClose,
}: IDsgvoDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>Datenschutzerklärung</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          <div dangerouslySetInnerHTML={{ __html: configObject.gdpr_html }} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
}
